import { render, staticRenderFns } from "./AddItemComponent.vue?vue&type=template&id=577cced1&scoped=true"
import script from "./AddItemComponent.vue?vue&type=script&lang=js"
export * from "./AddItemComponent.vue?vue&type=script&lang=js"
import style0 from "./AddItemComponent.vue?vue&type=style&index=0&id=577cced1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577cced1",
  null
  
)

export default component.exports